import ApiRequest from './Components/ApiRequest';

class ElementViewLogger {
    constructor(className, type) {
        this.elements = [];
        this.type = type;
        this.className = className;

        this.update();

        document.addEventListener('scroll', () => this.logElements());


    }

    update() {
        this.registerElements();
        this.logElements();
    }

    registerElements() {
        let temp_array = [];
        let tmp = document.getElementsByClassName(this.className);
        let length = tmp.length;

        for (var i = 0; i < length; i++) {
            temp_array.push(tmp[i]);
        }

        this.elements = temp_array;

        this.elements = this.elements.map((e) => {
            e.viewed = false;
            return e;
        });
    }

    logCard(e) {
        let userUid = e.getAttribute('data-user-uid-log');
        if (isNaN(userUid)) return;

        let requestUrl = `card/views/${userUid}`;

        if (window.loggedInUser) {
            requestUrl += `/${window.loggedInUser.uid}`;
        }

        let request = new ApiRequest();
        request.post(requestUrl, {}, () => { });
    }

    logElement(e) {
        switch (this.type) {
            case 'card': this.logCard(e);
        }
    }

    logElements() {
        let windowHeight = window.innerHeight;

        this.elements = this.elements.map((e) => {
            if (!e.viewed) {
                let pos = e.getBoundingClientRect();
                if (pos.height > 0 && (windowHeight - 100) > pos.top) {
                    e.viewed = true;
                    this.logElement(e);
                }
            }
            return e;
        });
    }
}

$(document).ready(() => {
    // step 1. add classname to the elements
    // step 2. add data-user-uid-log to the elements (needs to log params)
    window.cardLogger = new ElementViewLogger('logCard', 'card'); // input is the class name of the element
});